module.exports = __webpack_public_path__ + "img/GH-kyujin-jimu003.967de58d.webp";